import React, { Component } from 'react';
import {
	IChartProps,
	IChartState,
} from './models';
import { inject, observer } from 'mobx-react';
import ScatterChartComponent from '@kurtosys/ksys-app-components/dist/components/charting/ScatterChart';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import { IScatterChartProps } from '@kurtosys/ksys-app-components/dist/components/charting/ScatterChart/models';
import { computed } from 'mobx';

@inject('appStore', 'chartStore')
@observer
export class Chart extends Component<IChartProps, IChartState> {
	static configurationKey: 'chart' = 'chart';
	static styleKey: 'chart' = 'chart';
	constructor(props: IChartProps) {
		super(props);
	}

	@computed
	get formatters(): any {
		const formatters: any = {
			x: undefined,
			y: undefined,
		};
		const scatterChartProps = this.props.chartStore && this.props.chartStore.props;
		if (scatterChartProps) {
			const { elementOverrides } = scatterChartProps;
			formatters.x = elementOverrides && elementOverrides.xAxis && elementOverrides.xAxis.tickFormatter;
			formatters.y = elementOverrides && elementOverrides.yAxis && elementOverrides.yAxis.tickFormatter;
		}
		return formatters;
	}

	renderTooltip = (tooltipInput: any) => {
		const { active, payload } = tooltipInput;
		return <CustomTooltip active={ active } payload={ payload } formatters={ this.formatters } />;
	}

	applyCustomTooltip(props: IScatterChartProps): IScatterChartProps {
		if (!props.elementOverrides) {
			props.elementOverrides = {};
		}
		if (!props.elementOverrides.tooltip) {
			props.elementOverrides.tooltip = {};
		}
		props.elementOverrides.tooltip.content = this.renderTooltip;
		return props;
	}

	render() {
		const { className, chartStore } = this.props;

		if (!chartStore) {
			return null;
		}

		let scatterChartProps = chartStore.props;
		if (chartStore.useCustolTooltip) {
			scatterChartProps = this.applyCustomTooltip(scatterChartProps);
		}

		return (
			<Wrapper className={ className }>
				<ScatterChartComponent { ...scatterChartProps } />
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(Chart, 'chart');

